import type { ReactNode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './config/routes';
import { AppProviders } from './providers/AppProviders';

const router = createBrowserRouter(routes);

/**
 * The app.
 *
 * Providers, then the router, and nothing else. Business logic never lands here — the shell
 * composes, features decide (CLAUDE.md > What NOT to do).
 */
export const App = (): ReactNode => (
  <AppProviders>
    <RouterProvider router={router} />
  </AppProviders>
);
